'use strict';

exports.__esModule = true;
exports['default'] = lifecycle;

var _validators = require('../../utils/validators');

function lifecycle(values) {
  return function (target) {
    (0, _validators.validateClass)(target, 'lifecycle');
    Object.keys(values).forEach(function (name) {
      Object.defineProperty(target.prototype, name, {
        value: values[name]
      });
    });
  };
}